import { IBlock } from '../../types/content';

/**
 * Gets the array indices to get to the block/column/element
 */
const getStateArrayIndices = (state: IBlock[], blockId: string, columnId: string, elmId: string) => {
    const blockArrIdx = state.findIndex((block: IBlock) => block.index === blockId);
    if (blockArrIdx === -1) {
        return { blockArrIdx, columnArrIdx: -1, elmArrIdx: -1 };
    }
    const columnArrIdx = state[blockArrIdx].content.columns.findIndex((col) => col.columnIdx === columnId);
    if (columnArrIdx === -1) {
        return { blockArrIdx, columnArrIdx, elmArrIdx: -1 };
    }
    let elmArrIdx = -1;
    if (elmId) {
        elmArrIdx = state[blockArrIdx].content.columns[columnArrIdx].columnItems.findIndex(
            (elm) => elm.elmIdx === elmId
        );
    }
    return { blockArrIdx, columnArrIdx, elmArrIdx };
};

export default getStateArrayIndices;
